import { useEffect, useState } from 'react';
import { matchPath, useLocation } from 'react-router';
import { matchRoutes } from 'react-router-dom';

export const COLLECTION_PATH_NAMES = [
    '/collection/*',
    '/localcontent/*',
    '/marketing/*',
    '/collectionmgmt/*',
    '/merchandising/*'
];

function calculateIsSticky(pathname: string) {
    // Do not show sticky header on reporting page
    if (matchPath('/reporting/*', pathname)) {
        return false;
    }

    const toggleStickyValue = !!matchRoutes(
        COLLECTION_PATH_NAMES.map(path => ({ path })),
        pathname
    )
        ? 185
        : 106;

    return (window.scrollY || window.pageYOffset) > toggleStickyValue;
}

export const useStickyHeader = () => {
    const { pathname } = useLocation();
    const [isSticky, setIsSticky] = useState(() => calculateIsSticky(pathname));

    useEffect(() => {
        const handleScroll = () => {
            setIsSticky(calculateIsSticky(window.location.pathname));
        };

        window.addEventListener('scroll', handleScroll);

        return () => {
            window.removeEventListener('scroll', handleScroll);
        };
    }, []);

    return { isSticky };
};
